// WebSocketService.ts
import { EventEmitter } from 'events';

import { pushReceivedMessage } from '../redux/slices/OcppMessageSlicev2';
import { store } from '../redux/store';

class WebSocketService {
  private socket: WebSocket | null = null;

  private eventEmitter = new EventEmitter();

  /**
   * Function to connect socket
   * @param {any} url - The WebSocket server URL
   */
  connect(url: string) {
    // Close existing connection before creating a new one
    if (this.socket) {
      try {
        console.log('🔌 Closing previous WebSocket...');
        this.socket.close();
      } catch (even) {
        console.error('Error closing socket:', even);
      }
    }

    /**
     * Create new socket connection
     */
    this.socket = new WebSocket(url);

    /**
     * Establish a connection
     */
    this.socket.onopen = () => {
      console.log('WebSocket connected');
    };

    /**
     * Emitter for web socket messages
     */
    this.socket.onmessage = (event) => {
      const receivedData: any = JSON.parse(event.data);
      store.dispatch(pushReceivedMessage(receivedData));
      this.eventEmitter.emit('message', receivedData);
    };

    /**
     * Console websocket error
     */
    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };

    /**
     * Console when web socket connection closes
     */
    this.socket.onclose = () => {
      console.log('WebSocket disconnected');
    };
  }

  /**
   * Function to disconnect socket
   */
  disconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  /**
   * Function to send messages to socket
   * @param {any} message - The message object to send
   */
  sendMessage(message: object) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    } else {
      console.warn('WebSocket is not connected');
    }
  }

  /**
   * Function to establish listener from a component
   * @param {any} callback callback
   */
  subscribe(callback: (data: any) => void) {
    this.eventEmitter.on('message', callback);
  }

  /**
   * Function to disable/off connection to a event listener
   * @param {any} callback callback
   */
  unsubscribe(callback: (data: any) => void) {
    this.eventEmitter.off('message', callback);
  }
}

const webSocketService = new WebSocketService();
export default webSocketService;
